import React, { forwardRef } from 'react';
import cn from 'classnames';
import styles from './TableBody.module.scss';

const TableBody = forwardRef(({ className, ...props }, ref) => {
  return <tbody {...props} ref={ref} className={cn(styles.root, className)} />;
});

export default TableBody;
